import SlideMedia from './SlideMedia';

export default SlideMedia;
